/**
 * 構造化データテーブル表示
 */

import { Table, Text, ScrollArea, Code } from "@mantine/core";

/**
 * オブジェクトをフラット化するヘルパー（再帰的）
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function flattenObject(obj: any, prefix = ""): Record<string, string> {
  const result: Record<string, string> = {};

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

    const value = obj[key];
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (value === null) {
      result[newKey] = "null";
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === "object" && item !== null) {
          Object.assign(result, flattenObject(item, `${newKey}[${index}]`));
        } else {
          result[`${newKey}[${index}]`] = String(item);
        }
      });
    } else if (typeof value === "object") {
      Object.assign(result, flattenObject(value, newKey));
    } else {
      result[newKey] = String(value);
    }
  }

  return result;
}

interface StructuredDataTableProps {
  data: Record<string, unknown>;
}

/**
 * 構造化データを人間が見やすいテーブル形式で表示するコンポーネント
 */
export function StructuredDataTable({ data }: StructuredDataTableProps) {
  const flattened = flattenObject(data);
  const rows = Object.entries(flattened).map(([key, value]) => {
    return (
      <Table.Tr key={key}>
        <Table.Td style={{ verticalAlign: "top" }}>
          <Text size="xs" fw={500} c="dimmed">
            {key}
          </Text>
        </Table.Td>
        <Table.Td>
          <Text size="xs" style={{ whiteSpace: "pre-wrap" }}>
            {value}
          </Text>
        </Table.Td>
      </Table.Tr>
    );
  });

  return (
    <Table
      variant="simple"
      horizontalSpacing="xs"
      verticalSpacing="xs"
      withColumnBorders
      withTableBorder
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={180}>項目キー</Table.Th>
          <Table.Th>解析内容</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
}

interface JsonPreviewProps {
  data: unknown;
}

/**
 * JSON形式プレビュー
 */
export function JsonPreview({ data }: JsonPreviewProps) {
  return (
    <ScrollArea>
      <Code block style={{ fontSize: "11px", padding: "8px" }}>
        {JSON.stringify(data, null, 2)}
      </Code>
    </ScrollArea>
  );
}
